<script setup lang="ts">
defineProps<{
  prev?: PostItem | null;
  next?: PostItem | null;
}>();

const { currentPalette } = useTheme();
</script>

<template>
  <section
    class="post-navigation sticky bottom-0 z-20 h-16 lg:h-[4.375rem] lg:py-5 select-none flex flex-col items-stretch justify-center"
    :class="[currentPalette.bg]"
  >
    <div class="post-navigation__container container">
      <div
        class="post-navigation__wrapper flex items-center justify-between gap-4 lg:gap-16"
      >
        <div
          class="post-navigation__side post-navigation__side--start flex items-center justify-start grow basis-1/2 min-w-0 max-w-min"
        >
          <slot name="start">
            <PostNavigationButton v-if="prev" type="prev" :post="prev" />
          </slot>
        </div>
        <div
          class="post-navigation__side post-navigation__side--end flex items-center justify-end grow basis-1/2 min-w-0 max-w-min"
        >
          <slot name="end">
            <PostNavigationButton v-if="next" type="next" :post="next" />
          </slot>
        </div>
      </div>
    </div>
  </section>
</template>
